import { ITypeTicketCollectionData } from 'meta/pages/v4/typeticketcollection'

export type TypeTicketState = {
  typeticketcollections: Record<string, ITypeTicketCollectionData>
}

export const initialState: TypeTicketState = {
  typeticketcollections: {},
}
